import styled, { keyframes } from 'styled-components'

const dotPulseBefore = keyframes`0% { box-shadow: 9984px 0 0 -5px; } 30% { box-shadow: 9984px 0 0 2px; } 60%, 100% { box-shadow: 9984px 0 0 -5px; }`

const dotPulse = keyframes` 0% { box-shadow: 9999px 0 0 -5px; } 30% { box-shadow: 9999px 0 0 2px; } 60%, 100% { box-shadow: 9999px 0 0 -5px; }`

const dotPulseAfter = keyframes`0% { box-shadow: 10014px 0 0 -5px; } 30% { box-shadow: 10014px 0 0 2px; } 60%, 100% { box-shadow: 10014px 0 0 -5px; }`

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  margin: 1.8rem;
  color: #fff;
`

export const ProcessedText = styled.p`
  font-style: italic;
  text-align: center;
  font-size: 0.85rem;
  margin: 2rem 0;
  color: #fff;
`

export const ProgressBarContainer = styled.div`
  width: 80%;
  margin: 0 auto;
  border: 1px solid #ddd;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const Progress = styled.div<{
  processed: number
  total: number
  progressBar: number
}>`
  background-color: transparent;
  position: relative;
  border: 1px solid #fff;
  transition: width 0.3s;
  max-width: 60%;
  width: ${({ total }) => (total / total) * 100}%;
  border-radius: 13px;
  height: 12px;
  &::before {
    content: '';
    width: ${({ progressBar }) => `${progressBar}%`};
    background-color: #fff;
    border-radius: 13px;
    height: 8px;
    position: absolute;
    top: 1px;
    left: 1px;
  }
`

export const DotPulse = styled.div`
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #ffffff;
  color: #ffffff;
  box-shadow: 9999px 0 0 -5px;
  animation: ${dotPulse} 1.5s infinite linear;
  animation-delay: 0.25s;

  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #ffffff;
    color: #ffffff;
  }

  &::before {
    box-shadow: 9984px 0 0 -5px;
    animation: ${dotPulseBefore} 1.5s infinite linear;
    animation-delay: 0s;
  }

  &::after {
    box-shadow: 10014px 0 0 -5px;
    animation: ${dotPulseAfter} 1.5s infinite linear;
    animation-delay: 0.5s;
  }
`
